import HtmlHelper from '../utils/html-helper';
import HttpHelper from '../utils/http-helper';

export default class StaticStateModule {

    constructor(callerModule) {
        this.regionSelect = document.querySelector('#regionSelect');
        this.regionResetButton = document.querySelector('#regionResetButton');

        this.regions = [];
        this.regionsSelected = '';
        this.labelSelected = '';
        this.callerModule = callerModule;
    }

    addEventListener() {
        if (this.regionSelect?.attributes?.getNamedItem('infoText')?.value) {
            this.regionSelect.addEventListener('change', () => {
                this.regionsSelected = this.regionSelect.value;
                this.labelSelected = this.regionSelect.options[this.regionSelect.selectedIndex].text;
                if (!!this.regionsSelected) {
                    const region = this.regions.find(region => region._id === this.regionsSelected)
                    if (region.all) {
                        const infoTexts = this.regions
                            .filter(region => !region.all)
                            .reduce((html,region) => {
                            html += `<h4 class="p-none">${region.nameOrigin}:</h4><div>${region.infoText}</div>`;
                            return html
                        }, '')
                        this.renderInfoText(infoTexts);
                    } else {
                        this.renderInfoText(`<h4 class="p-none">${region.nameOrigin}:</h4><div>${region.infoText}</div>`);
                    }
                } else {
                    this.renderInfoText(undefined);
                }
            });
        } else if (!!this.callerModule) {
            this.regionSelect.addEventListener('change', () => {
                this.regionsSelected = this.regionSelect.value;
                this.labelSelected = this.regionSelect.options[this.regionSelect.selectedIndex].text;
                if (!!this.regionSelect.value) {
                    this.regionResetButton.removeAttribute('disabled');
                } else {
                    this.regionResetButton.setAttribute('disabled', 'true');
                }
                if (this.callerModule.dataTable) this.callerModule.dataTable.page = 1;
                if (this.callerModule.dataTable) this.callerModule.dataTable.offset = 0;
                this.callerModule.getData().then();
            });
            try {
                this.regionResetButton.addEventListener('click', () => {
                    this.regionResetButton.setAttribute('disabled', 'true');

                    if (this.callerModule.dataTable) this.callerModule.dataTable.page = 1;
                    if (this.callerModule.dataTable) this.callerModule.dataTable.offset = 0;
                    this.resetSelect().then(this.callerModule.getData());
                });
            } catch (e) {
                // console.warn('no btn')
            }
        } else {
            this.regionSelect.addEventListener('change', () => {
                this.regionsSelected = this.regionSelect.value;
                this.labelSelected = this.regionSelect.options[this.regionSelect.selectedIndex].text;
            });
        }
    }

    async getAllData() {
        const response = await HttpHelper.fetchData(`${location.origin}/api/public/static-state?sort={"sorting": -1, "nameOrigin":1}`);
        this.regions = response?.data;
    }

    async getId(id) {
        const response = await HttpHelper.fetchData(`${location.origin}/api/public/static-state/${id}`);
        return response?.data;
    }

    async resetSelect() {
        this.setAllRegionsOption();
        await this.loadLocations();
    }

    setAllRegionsOption() {
        this.regionSelect.innerHTML = null;
        this.regionSelect.value = '';
        this.regionsSelected = '';
        this.labelSelected = '';
        try {
            this.regionResetButton.setAttribute('disabled', 'true');
        } catch (e) {

        }

        const defaultOption = document.createElement('OPTION');
        defaultOption.innerHTML = 'Bitte wählen Sie ein Bundesland';
        defaultOption.value = '';
        this.regionSelect.appendChild(defaultOption);
    }

    async loadLocations() {
        this.setAllRegionsOption();
        await this.getAllData().then(() => {
            this.regions.forEach?.((region) => {
                const newOption = document.createElement('OPTION');
                newOption.innerHTML = region.nameOrigin;
                newOption.setAttribute('label', region.nameOrigin);
                newOption.value = region._id;
                this.regionSelect.appendChild(newOption);
            });

            this.regionSelect.value = '';
            this.regionSelect.removeAttribute('disabled');
        });
    }

    renderInfoText(infoText) {
        const infoTextP = document.querySelector('#infoText');
        infoTextP.innerHTML = null;
        if (infoTextP && infoText) {
            infoTextP.appendChild(HtmlHelper.createElementFromHTML(`<article class="stateInfo">${infoText}</article>`));
        }
    }
}

